import { Route, Navigate } from "react-router-dom";
import { peekDemoBypass, DemoBypassGuard, landingFor } from './helpers';
import lazyWithRetry from '../../utils/lazyWithRetry';

// Lazy-loaded pages
const ClientPortalPage = lazyWithRetry(() => import('../../features/client-portal/ClientPortalPage'));
const ClientGettingStartedPage = lazyWithRetry(() => import('../../pages/ClientGettingStartedPage'));
const ClientInsurancePage = lazyWithRetry(() => import('../../pages/client-portal/ClientInsurancePage'));
const ClientMigrationWizard = lazyWithRetry(() => import('../../features/client-migration/ClientMigrationWizard'));
const RescheduleRequestPage = lazyWithRetry(() => import('../../features/client-portal/RescheduleRequestPage'));
const PortalPracticeGate = lazyWithRetry(() => import('../../features/client-portal/components/PortalPracticeGate'));

/**
 * Client Routes - Client Portal Routes
 * Routes accessible to client users
 */
export function ClientRoutes({ user, isClientUser }) {
  return (
    <>
              {/* Client Routes */}
              <Route
                path="/client"
                element={
                  user === null
                    ? <div>Checking login...</div>
                    : (user && peekDemoBypass('/client', ['client','parent_of_client','part_of_couple']))
                    ? <DemoBypassGuard><PortalPracticeGate><ClientPortalPage /></PortalPracticeGate></DemoBypassGuard>
                    : user && isClientUser(user)
                    ? <PortalPracticeGate><ClientPortalPage /></PortalPracticeGate>
                    : <DemoBypassGuard><Navigate to={landingFor(user)} /></DemoBypassGuard>
                }
              />

              {/* Standalone client portal wrappers are obsolete — the tabbed
                  /client portal is the single canonical experience. */}
              <Route path="/client/appointments" element={<Navigate to="/client?tab=appointments" replace />} />
              <Route path="/client/messages" element={<Navigate to="/client?tab=messages" replace />} />
              <Route path="/client/paperwork" element={<Navigate to="/client?tab=paperwork" replace />} />
              <Route path="/client/forms" element={<Navigate to="/client?tab=paperwork" replace />} />
              <Route path="/client/documents" element={<Navigate to="/client?tab=documents" replace />} />
              <Route path="/client/health" element={<Navigate to="/client?tab=health" replace />} />
              <Route path="/client/billing" element={<Navigate to="/client?tab=payments" replace />} />
              <Route path="/client/payments" element={<Navigate to="/client?tab=payments" replace />} />
              <Route path="/client/resources" element={<Navigate to="/client?tab=resources" replace />} />
              <Route path="/client/notifications" element={<Navigate to="/client?tab=notifications" replace />} />

              <Route
                path="/client/appointments/reschedule-requests/:requestId"
                element={
                  user === null
                    ? <div>Checking login...</div>
                    : user && isClientUser(user)
                    ? <RescheduleRequestPage />
                    : <Navigate to="/login" />
                }
              />
              <Route
                path="/client/insurance"
                element={
                  user === null
                    ? <div>Checking login...</div>
                    : user && isClientUser(user)
                    ? <ClientInsurancePage />
                    : <Navigate to="/login" />
                }
              />

              {/* Client Getting Started — onboarding guide for new clients */}
              <Route
                path="/client/getting-started"
                element={
                  user === null
                    ? <div>Checking login...</div>
                    : user && isClientUser(user)
                    ? <ClientGettingStartedPage />
                    : <Navigate to="/login" />
                }
              />

              {/* Migration Onboarding Wizard (existing clients transitioning) */}
              <Route
                path="/client/migration"
                element={
                  user === null
                    ? <div>Checking login...</div>
                    : user && isClientUser(user)
                    ? <ClientMigrationWizard onComplete={() => { window.location.href = '/client'; }} />
                    : <Navigate to="/login" />
                }
              />

    </>
  );
}
